export { TagInputModule } from './tag-input.module';

export {
    TagInputDropdown, DeleteIconComponent, TagInputForm, TagRipple, TagComponent, TagInputComponent
} from './components/index';


export * from './core/pipes';
